<script lang="ts">
  import type { Snippet } from 'svelte';
  interface Props {
    message?: string;
    intent?: 'error' | 'success' | 'info';
    children?: Snippet;
  }
  let { message = '', intent = 'info', children }: Props = $props();
</script>

<p role="status" class="inline-message" class:error={intent === 'error'} class:success={intent === 'success'}>
  {#if message || children}
    <strong>{intent === 'error' ? 'Error: ' : intent === 'success' ? 'Success: ' : ''}</strong
    >{#if children}{@render children()}{:else}{message}{/if}
  {/if}
</p>

<style>
  .inline-message {
    overflow-wrap: anywhere;
    margin: 0;
    padding: 0;
  }
  .error strong {
    color: var(--theme-danger);
  }
  .success strong {
    color: var(--theme-success);
  }
</style>
